function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}
parcelRequire.register("7o1q3", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $560be01eba0f70c0$export$6503ec6e8aabbaf; }, function (v) { return $560be01eba0f70c0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $560be01eba0f70c0$export$f7ad0328861e2f03; }, function (v) { return $560be01eba0f70c0$export$f7ad0328861e2f03 = v; });
var $560be01eba0f70c0$export$6503ec6e8aabbaf;
var $560be01eba0f70c0$export$f7ad0328861e2f03;
"use strict";
var $560be01eba0f70c0$var$mapping = {};
function $560be01eba0f70c0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$560be01eba0f70c0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $560be01eba0f70c0$var$resolve(id) {
    var resolved = $560be01eba0f70c0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$560be01eba0f70c0$export$6503ec6e8aabbaf = $560be01eba0f70c0$var$register;
$560be01eba0f70c0$export$f7ad0328861e2f03 = $560be01eba0f70c0$var$resolve;

});

parcelRequire.register("kHeqQ", function(module, exports) {

module.exports = import("./" + (parcelRequire("7o1q3")).resolve("j84av")).then(()=>parcelRequire("65iGt"));

});

parcelRequire.register("eRPsA", function(module, exports) {

module.exports = import("./" + (parcelRequire("7o1q3")).resolve("7oF5S")).then(()=>parcelRequire("fGw1i"));

});

parcelRequire.register("h0rPV", function(module, exports) {

module.exports = import("./" + (parcelRequire("7o1q3")).resolve("3apyP")).then(()=>parcelRequire("47L8Q"));

});

parcelRequire.register("7Zukx", function(module, exports) {

module.exports = import("./" + (parcelRequire("7o1q3")).resolve("7SeY3")).then(()=>parcelRequire("gbcUP"));

});

parcelRequire.register("8doCT", function(module, exports) {

module.exports = import("./" + (parcelRequire("7o1q3")).resolve("6M7G9")).then(()=>parcelRequire("jJNSA"));

});

var $d318b57b11a5803a$exports = {};

(parcelRequire("7o1q3")).register(JSON.parse('{"cZXYu":"base.211e01a3.js","j84av":"faq.f1bacb3a.js","7oF5S":"form.e39b89ef.js","3apyP":"legacy.63113923.js","7SeY3":"swiper.cc5fe3c4.js","6M7G9":"map.d361f641.js"}'));


(parcelRequire("kHeqQ"));

(parcelRequire("eRPsA"));

(parcelRequire("h0rPV"));

(parcelRequire("7Zukx"));

(parcelRequire("8doCT"));
(()=>{
    const kwBody = document.querySelector("body.kw-body");
    const callbackBtn = document.getElementById("kw_cta_callback_mob");
    const ctaPhotoBtn = document.getElementById("kw_cta_photo");
    const callbackDialog = document.getElementById("kw_dialog_callback");
    const videoDialog = document.getElementById("kw_dialog_video");
    const videoWrap = videoDialog === null || videoDialog === void 0 ? void 0 : videoDialog.querySelector("div.kw-dialog_video-wrap");
    const videoCloseBtn = videoDialog.querySelector("button.kw-button_close");
    const ctaCloseBtn = callbackDialog === null || callbackDialog === void 0 ? void 0 : callbackDialog.querySelector("button.kw-button_close");
    const bodyScroll = (force = true)=>{
        if (force) kwBody.classList.remove("kw-noscroll");
        else kwBody.classList.add("kw-noscroll");
    };
    const dialogClose = (dialog, cb = ()=>{})=>{
        cb();
        bodyScroll(true);
        dialog.close();
    };
    const detectOutsideDialogClick = (e, dialog, cb = ()=>{})=>{
        e.stopPropagation();
        const rect = dialog === null || dialog === void 0 ? void 0 : dialog.getBoundingClientRect();
        if (!rect) return;
        if (e.clientY < rect.top || e.clientY > rect.bottom || e.clientX < rect.left || e.clientX > rect.right) dialogClose(dialog, cb);
    };
    const videoDialogReset = ()=>{
        videoWrap.innerHTML = "";
    };
    const showCtaDialog = (e)=>{
        e.stopPropagation();
        bodyScroll(false);
        callbackDialog === null || callbackDialog === void 0 ? void 0 : callbackDialog.showModal();
    };
    ctaPhotoBtn.onclick = showCtaDialog;
    callbackBtn.onclick = showCtaDialog;
    videoCloseBtn.onclick = (e)=>{
        e.stopPropagation();
        dialogClose(videoDialog, videoDialogReset);
    };
    ctaCloseBtn.onclick = (e)=>{
        e.stopPropagation();
        dialogClose(callbackDialog);
    };
    videoDialog.onclick = (e)=>detectOutsideDialogClick(e, videoDialog, videoDialogReset);
    callbackDialog.onclick = (e)=>detectOutsideDialogClick(e, callbackDialog);
    const videoBlocks = document.querySelectorAll(".kw-video");
    videoBlocks.forEach((item)=>{
        item.onclick = ()=>{
            var _item_querySelector, _item_querySelector_content;
            const iframe = (_item_querySelector = item.querySelector("template")) === null || _item_querySelector === void 0 ? void 0 : (_item_querySelector_content = _item_querySelector.content) === null || _item_querySelector_content === void 0 ? void 0 : _item_querySelector_content.cloneNode(true);
            if (!iframe) return;
            bodyScroll(false);
            videoWrap.innerHTML = "";
            videoWrap.appendChild(iframe);
            videoDialog.showModal();
        };
    });
    const openMenu = ()=>{
        var _document_querySelector, _document_querySelector_classList;
        (_document_querySelector = document.querySelector("nav.kw-nav")) === null || _document_querySelector === void 0 ? void 0 : (_document_querySelector_classList = _document_querySelector.classList) === null || _document_querySelector_classList === void 0 ? void 0 : _document_querySelector_classList.toggle("show");
    };
    const navClose = document.getElementById("kw_nav_close");
    const menuBtn = document.getElementById("kw_mob_menu");
    const menuBtnLegacy = document.querySelector(".app-header .menu_btn");
    menuBtn === null || menuBtn === void 0 ? void 0 : menuBtn.onclick = openMenu;
    menuBtnLegacy === null || menuBtnLegacy === void 0 ? void 0 : menuBtnLegacy.onclick = openMenu;
    navClose === null || navClose === void 0 ? void 0 : navClose.onclick = openMenu;
    const fire = (msg, mod = "success")=>{
        if (mod == "success") {
            const dialogList = document.getElementsByTagName("dialog");
            for (const el of dialogList)el === null || el === void 0 ? void 0 : el.close();
        }
        const newDiv = document.createElement("div");
        newDiv.innerHTML = `<span class="kw-callback-msg ${mod}">${msg}</span>`;
        videoWrap.innerHTML = "";
        videoWrap.appendChild(newDiv);
        bodyScroll(false);
        videoDialog.showModal();
    };
    document.addEventListener("fetchit:success", (e)=>{
        const { response: response  } = e.detail;
        fire(response.message);
    });
    document.addEventListener("fetchit:error", (e)=>{
        const { response: response  } = e.detail;
        fire(response.message, "error");
    });
})();


//# sourceMappingURL=base.211e01a3.js.map
